import { render } from "./PHOTOSHOP_UPLOAD.vue?vue&type=template&id=45b3aa98"
import script from "./PHOTOSHOP_UPLOAD.vue?vue&type=script&lang=js"
export * from "./PHOTOSHOP_UPLOAD.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__